import { MdAttachMoney, MdOutlineWarningAmber } from "react-icons/md";
import { IoTicketOutline } from "react-icons/io5";
import { IoIosPeople } from "react-icons/io";
import { FaPeopleArrows, FaRegAddressCard } from "react-icons/fa";
import { TbMathAvg, TbShoppingCartDiscount } from "react-icons/tb";
import { BsNodePlus } from "react-icons/bs";
import { AiOutlineEdit } from "react-icons/ai";
import { BiLinkExternal } from "react-icons/bi";
import { BsTrash, BsQuestionCircleFill } from "react-icons/bs";

import { COLORS } from "./colors";

export const ICONS = {
  moneyBlack20: <MdAttachMoney color={COLORS.black} size={20} />,
  moneyAccent20: <MdAttachMoney color={COLORS.mainAccent} size={20} />,
  ticketAccent20: <IoTicketOutline color={COLORS.mainAccent} size={20} />,
  ticketWhite20: <IoTicketOutline color={COLORS.white} size={20} />,
  ticketBlack20: <IoTicketOutline color={COLORS.black} size={20} />,
  threePeopleAccent20: <IoIosPeople color={COLORS.mainAccent} size={20} />,
  peopleArrowsAccent20: <FaPeopleArrows color={COLORS.mainAccent} size={16} />,
  scaleAccent20: <TbMathAvg color={COLORS.mainAccent} size={16} />,
  plusBlack25: <BsNodePlus color={COLORS.black} size={25} />,
  plus20: <BsNodePlus size={20} />,
  editBlack25: <AiOutlineEdit color={COLORS.black} size={25} />,
  warningBlack25: <MdOutlineWarningAmber color={COLORS.black} size={25} />,
  discount20Accent: (
    <TbShoppingCartDiscount color={COLORS.mainAccent} size={20} />
  ),
  external20: <BiLinkExternal size={20} />,
  membershipWhite20: <FaRegAddressCard color={COLORS.white} size={20} />,
  membershipBlack20: <FaRegAddressCard color={COLORS.black} size={20} />,
  trashBlack20: <BsTrash color={COLORS.black} size={20} />,
  questionAccent20: (
    <BsQuestionCircleFill color={COLORS.mainAccent} size={20} />
  ),
};
